const getters = {
  getCurrentBusinessAccount: state => state.currentBusinessAccount,
  getListBank: state => state.listBank,
  getListMomo: state => state.listMomo,
  getListBankAccount: state => state.listBankAccount,
  getListMomoAccount: state => state.listMomoAccount,
  getListTransfer: state => state.listTransfer,
  getTotalTransfer: state => state.totalTransfer,
  getListTopUp: state => state.listTopUp,
  getListTransaction: state => state.listAllTransaction,
  getTotalTransaction: state => state.totalTransaction,
  getListIncoming: state => state.listIncoming,
  getListOutgoing: state => state.listOutgoing,
  getAvailableBalance: state => state.availableBalance,
  getListVisaCards: state => state.listVisaCards
}

export default getters
